import { render, staticRenderFns } from "./OrderSubmitResult.vue?vue&type=template&id=419fe971&scoped=true"
import script from "./OrderSubmitResult.vue?vue&type=script&lang=js"
export * from "./OrderSubmitResult.vue?vue&type=script&lang=js"
import style0 from "./OrderSubmitResult.vue?vue&type=style&index=0&id=419fe971&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419fe971",
  null
  
)

export default component.exports